import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import { OrderRoutes } from '@ripeurs/common/types/gateway';

import { ApiV2Service } from '~app/services/api-v2.service';
import { UserService } from '~app/services/user.service';

import type { OrderType } from '@ripeurs/common/types/service';


@Injectable()
export class UtilityOrderHandler {
	constructor(
		private readonly _api: ApiV2Service,
		private readonly _user: UserService,
	) {}

	public getOrders() {
		return this._api.request<OrderRoutes.GetOrders.Def>(OrderRoutes.GetOrders.config, {
			query: {
				regionId: this._user.loggedGetRegion().id,
				slotDate: {
					from: new Date,
					to: new Date,
				},
			},
		}).pipe(map((result) => {
			const slotsObject: {
				[k: string]: {
					slot: OrderType.Order['slot'],
					orders: OrderType.Order[],
				},
			} = {};

			for (const order of result.data.orders) {
				// Hide Ripeurs
				if (order.location.address.blocks[0].toUpperCase() === '100 AVENUE DU GÉNÉRAL LECLERC'
					&& order.location.address.blocks[1].toUpperCase() === '93500 PANTIN') {
					continue;
				}
				let slot = slotsObject[order.slot.id];
				if (slot === undefined) {
					slot = slotsObject[order.slot.id] = {
						slot: order.slot,
						orders: [],
					};
				}
				slot.orders.push(order);
			}

			return Object.values(slotsObject).sort((a, b) => {
				return a.slot.sort - b.slot.sort;
			});
		}));
	}

	public getOrder({ id }: { id: string }) {
		return this._api.request<OrderRoutes.GetOrder.Def>(
			OrderRoutes.GetOrder.config,
			{ params: { id } },
		).pipe(
			map((result) => result.data.order),
		);
	}
}
